import { combineReducers } from 'redux';
import cluster from './cluster/clusterReducer';
import volume from './volume/volumeReducer';

export default combineReducers({
	cluster,
	volume,
});
